export default function FAQHeader() {
  return (
    <div className='text-center mb-14 space-y-4'>
      <h2 className='text-4.5xl font-semibold leading-[141%]'>
        Frequently Asked Questions
      </h2>
      <p className='text-white/60 text-lg md:text-base'>
        Can't find the answer you're looking for?{' '}
        <a
          href='mailto:support@wayfinder.ai'
          className='text-white underline hover:text-white/80 transition-colors'
        >
          Contact us
        </a>{' '}
        for assistance.
      </p>
    </div>
  );
}
